const WorkGroup = () => {
    return (
       
        <div class="page-content relative">

            <p>1. Prof. Dr. Mehmet Serhat YILMAZ / Başkan</p>
            <p>2. Prof. Dr. Tahir KODAL</p>
            <p>3. Prof. Dr. Orhan AVCI</p>
            <p>4. Prof. Dr. Nurten ÇETİN</p>
            <p>5. Prof. Dr. Hacer TOPAKTAŞ ÜSTÜNER</p>
            <p>6. Prof. Dr. Sevtap DEMİRCİ</p>
            <p>7. Prof. Dr. Nuri KARAKAŞ</p>
            <p>8. Prof. Dr. Mesut ÇAPA</p>
            <p>9. Prof. Dr. Ayşe YANARDAĞ</p>
            <p>10. Doç. Dr. Arzu VARLI BİNAGÜL</p>
            <p>11. Doç. Dr. Hatice GÜZEL MUMYAKMAZ</p>




            <p>&nbsp;</p>
            <h3>PROJEDEN SORUMLU UZMANLAR</h3>
            <p>Aslı AKDOĞANBULUT İNSAN – Yüksek Kurum Uzmanı</p>
            <p>Duygu TÜRKER ÇELİK – Yüksek Kurum Uzmanı</p>
            <p>Nurdoğan AKDAĞ – Bilişim Uzmanı</p>

        </div>
        
    )
}
export default WorkGroup